import React, { useState } from "react";
import { Link } from "react-router-dom";

const SummonAnimals = () => {
  const [expandedLevels, setExpandedLevels] = useState({});

  const toggleLevel = (level) => {
    setExpandedLevels((prev) => ({
      ...prev,
      [level]: !prev[level],
    }));
  };

  const animalsByLevel = {
    1: [
      {
        name: "Skunk",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=1310",
        description:
          "Spray Musk has a very reasonable DC at 16, no recharge and very good effects (Sickened 1 on a success, Sickened 2 on a fail). Screw Goblin Pox, this creature is a much safer goblin pox that can also be used again if it doesn't die (and if it does die, well the enemy wasted actions so win/win). Alternate senses: Low-light vision, scent (40ft).",
      },
      {
        name: "Bloodseeker/Glass River Midge",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=51",
        description:
          "This creature is actually fairly decent for a creature -1. Of course, it probably dies in 1 hit, but the hit bonus is quite solid for a level -1 creature (+8 is better than a level 1 martial and equal or below a level 2 martial depending on if they have a potency rune). It doesn't deal too much damage, but it can inflict drained 1 and if it hits then it has a decent chance of surviving a hit from a low level monster. I would summon this next to something and immediately attack. The glass river midge is technically better because it also has Camouflage but when would you need that? Alternate senses: Darkvision, Scent (60ft).",
      },
      {
        name: "Compsognathus",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=2914",
        description:
          "A reasonable hit bonus and a decent poison effect (enfeebled 1), along with reasonable damage if you land the poison. Alternate senses: Low-light vision, scent (30ft).",
      },
      {
        name: "Guard Dog",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=2924",
        description:
          "Actually does decent damage for a level 1 spell (2d4+1 if you have a frontline). Sure, you're summoning it right next to the monster and it will die in one hit, but whatever, you waste the monster's best action and potentially deal a bit of damage. That's worth it for a level 1 spell. Alternate senses: Low-light vision, Scent (30ft).",
      },
      {
        name: "Weasel",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=1364",
        description:
          "Your first grabber, and oh boy is it hilarious. +7 hit bonus is very reasonable at level 1, equivalent to a martial and… for some reason the monster grab, unlike the PC grapple, has no size restrictions. So this tiny weasel can pin down even a 100ft tall animated colossus with some luck. Grapple is a good condition to inflict with summons, because it leaves the enemy with only bad choices. They can either a) remain in place, flat-footed and immobilized which gives you positional advantage, b) attack the summon to try to kill it, which might not work, wastes actions and gives them MAP or c) try to escape the grapple, which wastes actions and gives them MAP. Alternate senses: Low-light vision, scent (60ft).",
      },
    ],
    2: [
      {
        name: "Giant Skunk",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=1311",
        description:
          "Upgrading the Skunk is the giant variation, which is basically the same as the last one, just a DC 1 higher, 15ft cone instead of 10ft line (much better area) and the sickened on a fail is 3 instead of 2. Absurdly good for a level 2 spell. Also has a chance to blind. Alternate senses: Low-light vision, Scent (40ft).",
      },
      {
        name: "Cave Scorpion",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=795",
        description:
          "+9 to-hit and grab. The venom is fairly useless as it only inflicts enfeebled and doesn't even do so until stage 2. Alternate senses: Darkvision, Tremorsense (30f)",
      },
      {
        name: "Goblin Dog",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=3028",
        description:
          "Sickened is a decent condition to inflict. Just spawn this in the middle of a few creatures and have it scratch itself. Or spawn it next to a bigger creature and have it scratch itself. The hit bonus isn't anything to write home about, but it can do a bit of damage if you want it to. The big draw is Goblin Pox. Alternate senses: Low-light vision, Scent (30ft).",
      },
      {
        name: "Hunting Spider",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=3207",
        description:
          "The DC is lower than Goblin Pox, but this Spider has something else going for it - Web. It may only have a +7 hit bonus, but you can have the Spider use Web twice per round and it should hit at some point. Sure, the opponent will probably escape on their first action, but not only does that waste an action, it also gives them MAP. The poison is also pretty decent if you can get it to land, inflicting flat-footed. Alternate senses: Darkvision, web sense",
      },
    ],
    3: [
      {
        name: "Giant Ant",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=2824",
        description:
          "Remember how summon animal used to be good because you could drag away creatures at level 6…, Bestiary 2): So paizo just printed a creature with Haul Away at level 3. Still subject to rulings regarding whether the creature can 'spin' while hauling another creature, but this is just deciding between whether this creature is broke or really broke.",
      },
      {
        name: "Giant Opossum",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=1253",
        description:
          "Amazing reposition ability… only against small and tiny creatures, Bestiary 3): This creature has a 15ft grab, which is already a pretty great ability. It does have a couple downsides compared to the ant though - first, its hit bonus is one lower (its grab is harder to escape from, however, DC20 instead of DC18). Second, it can only reposition enemies of small and tiny size, which is a big downside. Fortunately, this is summoning, if you're fighting small & tiny enemies, summon this, if not, don't. Alternate senses: Low-light vision, Scent (30ft).",
      },
      {
        name: "Cave Fisher",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=580",
        description:
          "A good summon for disrupting opponents' actions. The aim is to hit them with Sticky Filament, then keep using Pull Filament to reposition them so they have to spend actions moving back into position. Can also be useful if your DM uses a lot of difficult terrain, uneven ground or environmental hazards. Alternate senses: Darkvision",
      },
      {
        name: "Giant Toad",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=828",
        description:
          "A grabber with swallow whole (medium). Swallow whole is pretty good. The poison on this is also good if you can get it to stage 2, but it's difficult to apply seeing as its applied from creatures attacking the toad, not the toad attacking creatures. Alternate senses: Low-light vision, Scent (30ft).",
      },
      {
        name: "Giant Monitor Lizard",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=3088",
        description:
          "The, IMO, better version of the crocodile. The +1 hit bonus means it's easier to land just Grab when you want it, and the poison, although most enemies won't fail the save at this level, can be useful. Lurching Charge is decent if things move away from the lizard, though it prevents you grabbing afterwards. Also, it can be mounted. Alternate senses: Low-light vision, Scent (30ft).",
      },
      {
        name: "Pteranodon",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=3151",
        description:
          "Although this doesn't natively have any control elements, if the opponent has no ranged attacks or fly speed, you can just swoop every turn and they can't hit it. Past then, you only have to find a way to protect yourself (and your party). Alternate senses: Low-light vision, Scent (30ft).",
      },
      {
        name: "Slurk",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=3199",
        description:
          "Similar to how the hunting spider had Web, this thing has slime. Clumsy 1 and -5ft speed for a whole hour is no joke, even if the hit mod is only +9. 3 actions to remove it means they're never going to remove it in combat. Alternate senses: Darkvision",
      },
    ],
    4: [
      {
        name: "Giant Whiptail Centipede",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=581",
        description:
          "Your first huge creature. A pretty simple creature otherwise. Reach 15ft with Knockdown or Reach 10ft for a chance to poison (inflicting clumsy which is nice). Basically it's good because it can threaten and control a lot of space.",
      },
      {
        name: "Bunyip",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=62",
        description:
          "It's essentially an AoE Fear stapled to a summon spell. It's slow as heck and needs to transform to actually be relevant otherwise (choose snake for reach and grab), and even then the attack bonus certainly isn't good, but just for the capability for a 4th level spell to basically reproduce the effects of a 3rd level Fear (with a lower DC) on demand, this can be quite useful. Alternate senses: Blood scent, Darkvision, Scent (100ft)",
      },
      {
        name: "Chimpanzee Vistant",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=512",
        description:
          "This undead chimp sure has a lot going on. A single failed save against the poison means Sickened 1 for a whole day. Vengeful Presence is another neat ability that can cause some action wasting. Grab on the claw as well. The numbers are a bit low, but it still has some very good abilities. Alternate senses: Darkvision, Lifesense (60ft).",
      },
      {
        name: "Giant Mantis",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=3094",
        description:
          "Reach, Grab and Flying is a pretty good package for one creature. Unfortunately, it probably won't be able to grab creatures while flying because it needs to keep spending actions on Fly or it will fall. That being said, you can still grab creatures with a 5ft range at up to 10ft away to stop them doing anything. Alternate senses: Darkvision",
      },
    ],
    5: [
      {
        name: "Lion Visitant",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=513",
        description:
          "This upgrade to the Chimpanzee Visitant is very impressive. The chimpanzee was already good, but we added Pounce, Roar and it actually can do a decent amount of damage if you can get both Pack Attack and Sneak Attack triggering (though it won't hit too often). Alternate senses: Darkvision, Lifesense (60ft).",
      },
      {
        name: "Bore Worm Swarm",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=1083",
        description:
          "So you get kind of a 3rd level fireball of damage every round, plus the ability to inflict sickened 1 on a fail. Not the worst thing in the world.",
      },
      {
        name: "Brood Leech Swarm",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=712",
        description:
          "Decent venom effect, and there's no save against the blood draining bite so it actually does decent damage.",
      },
      {
        name: "Ogre Spider",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=814",
        description:
          "A fairly decent monster. Web is still a good ability and the poison isn't bad either (Clumsy 1 and enfeebled 1).",
      },
      {
        name: "Rhinoceros",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=3168",
        description:
          "A pretty simple, but effective monster. Just have it spam Rhinoceros Charge every round, making sure to move at least 20 ft. Knock back 5ft+Prone is huge, wasting 2 actions while the creature has to stand and move back into position.",
      },
      {
        name: "Owlbear",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=328",
        description:
          "Do you know why I like owlbears? Well that's because my first favourite animal is an Owl, my second is a Lion and my third favourite… is OWLBEARS. This D&Desque meme animal is unironically pretty good. Both Bloodcurdling Screech and Gnaw are solid abilities that do things even if the opponent passes the save and it has Grab. Not much else you can ask for really (well you could ask for a Lion Visitant).",
      },
    ],
    6: [
      {
        name: "Elephant",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=2993",
        description:
          "The Grabbing Trunk ability is incredibly good, able to waste multiple actions from the opponent every round. If your DM rules that the elephant is able to spin around to reposition the opponent behind them, this creature becomes the best choice at this level as it's effectively recasting a wall spell every round.",
      },
      {
        name: "Empress Bore Worm",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=1084",
        description:
          "Ignore Final Sacrifice synergy - we're after one ability: Corrosive Wake. The DC isn't great, so you need a lot of forced movement to make it work (like the elephant above - see issues with elephant rulings meaning this can potentially just deal ludicrous amounts of damage). Unfortunately, PF2e is kind of lacking in the forced movement department…. Outside of summons that is. Even without the infinite damage potential, the elephant's single move action can still drag a creature along 8 squares, dealing 24d6 acid damage. 2 move actions makes it 48d6 acid damage. Summon combo?",
      },
      {
        name: "Megalania",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=725",
        description:
          "Megalovania has a pretty decent venom and swallow whole (large) which can make it an effective controller. It's also huge with a 10ft reach so it threatens a lot of space.",
      },
    ],
    7: [
      {
        name: "Roc",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=3170",
        description:
          "Whoah, Paizo, calm down. This creature has everything. Gargantuan with massive reach. Improved Grab. Improved Push for when that's relevant. Snatch without the bad wording from the Quetzal. Flying Strafe which lets it pick up and carry off two creatures potentially. I don't know why you'd summon anything else.",
      },
      {
        name: "Mastodon",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=668",
        description:
          "Upgraded elephant, subject to all the same rulings and restrictions. Slightly higher speed.",
      },
      {
        name: "Giant Anaconda",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=3203",
        description:
          "A very solid grappler summon - Swallow Whole, Slither, push back for when grabbing just won't do, plenty of stuff this summon can do to control the battlefield.",
      },
      {
        name: "Giant Snapping Turtle",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=837",
        description:
          "A sidegrade from the Anacoda. Far more efficient at grabbing and swallowing due to improved grab, but lacks control elements otherwise.",
      },
      {
        name: "Khravgodon",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=1254",
        description:
          "Upgraded giant opossum. I do think by this level, this creature is a lot worse - competing with the Roc and Mastodon. It only has an advantage vs the Mastodon in that it can reposition large creatures (but it needs 2 actions to set up a grab, rather than 1) and it has no advantage compared to the Roc.",
      },
    ],
    8: [
      {
        name: "Deadly Mantis",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=3095",
        description:
          "Lots of stuff going on with this one. First, Leaping Grab lets it carry away creatures and grab them, which means lots of wasted actions. Second, rending mandibles is good against armoured foes. Third, Fling can be a good second turn ability if the opponent is still grabbed, as Leaping Grab won't let you carry them further away while keeping them grabbed.",
      },
      {
        name: "Goliath Spider",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=3209",
        description:
          "Incapacitation on the venom means it won't be doing much, but Web Tether applying restrained for 1 action is insanely good. Sure, the opponent will probably escape with their first action, but you're trading ½ an action for an action and their MAPless attack.",
      },
      {
        name: "Brontosaurus",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=2922",
        description:
          "Opening up with a pretty decent one. The massive space it threatens due to Gargantuan + 20ft reach on the tail means you can mostly just have it sit there and spam Tail Sweep to knock down (up to) 3 opponents per turn. Perhaps reposition it occasionally too.",
      },
      {
        name: "Mammoth",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=2994",
        description:
          "This larger Elephant isn't as insane as it has some competition now. Still reasonably solid to deny one creature a lot of actions, and it can do a bit of AoE with Dual Tusks. Not bad.",
      },
    ],
    9: [
      {
        name: "Purple Worm",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=2871",
        description:
          "Despite being the only choice at this level, this is a very solid creature. Improved Grab is always nice to see, but the venom is also very good. Swallow whole up to huge (though you don't get to use Fast Swallow). Thrash to use both Stinger and Jaws without MAP. Depending on DM ruling, you can start with a Huge boulder. Also depending on DM ruling, the boulder may not be destroyed after firing it, meaning it takes up even more space.",
      },
      {
        name: "Frost Worm",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=677",
        description:
          "Will always hold a special place in my heart as one of my party members in a 5e game died to a (homebrew) Frost Worm because they decided trekking out into the arctic wastes alone was a good idea… Anyway it has a solid Breath Weapon and is very good at triggering cold weaknesses. If you come up against things weak to cold this is fairly good. It lacks grab, but the bite does decent damage due to persistent. Worm Trill is fairly useless just because fascinated is fairly useless, unless you’re against casters who will pass the save anyway. Alternate senses: Darkvision.",
      },
    ],
    10: [
      {
        name: "Black Scorpion",
        url: "https://2e.aonprd.com/Monsters.aspx?ID=796",
        description:
          "Clumsy 2 at stage 1 poison is very good and the higher stages are even better. Rapid Stinging lets it apply poison to up to 3 creatures. Also has grab and an absolutely enormous threatened area (Gargantuan + 30ft reach).",
      },
    ],
  };

  return (
    <div className="summon-animals">
      <h1>Druid Summonable Animals</h1>
      <p>
        This page lists animals that can be summoned by druids using the Summon
        Animal spell in Pathfinder 2nd Edition, grouped by spell level. Only
        animals rated Gold or Blue in community rankings are included.
      </p>
      <p>
        <Link to="/pathfinder/primal-spells">View Primal Spells</Link>
      </p>

      {Object.entries(animalsByLevel).map(([level, animals]) => (
        <div key={level} className="level-group">
          <h2 onClick={() => toggleLevel(level)} style={{ cursor: "pointer" }}>
            Level {level} {expandedLevels[level] ? "▼" : "▶"}
          </h2>
          {expandedLevels[level] && (
            <ul>
              {animals.map((animal, index) => (
                <li key={index}>
                  {animal.url ? (
                    <a
                      href={animal.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {animal.name}
                    </a>
                  ) : (
                    animal.name
                  )}
                  {animal.description && (
                    <p
                      style={{
                        margin: "5px 0 10px 20px",
                        fontSize: "0.9em",
                        color: "#666",
                      }}
                    >
                      {animal.description}
                    </p>
                  )}
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
};

export default SummonAnimals;
